import { createSlice } from "@reduxjs/toolkit";
import {
  authForgotPassword,
  authLogin,
  authRegister,
  changePassword,
  fetchProfile,
  updateProfile,
  fetchAllSentNotification,
  CreateSentNotification,
  DeleteSentNotification,
  UpdateSentNotification,
  fetchNotificationDetail,
} from "../action/authAction";
import { pipSaveProfile, pipSaveSquareProfile } from "../../utils/pip";

const initialState = {
  isLoading: false,
  isToggle: false,
  profile: {},
  sentNotification: [],
  notificationDetailList: [],
};

export const authSlice = createSlice({
  name: "Auth",
  initialState: initialState,
  reducers: {
    toggleChange: (state, action) => {
      state.isToggle = action?.payload;
    },
  },
  extraReducers: (builder) => {
    // auth-register
    builder.addCase(authRegister.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authRegister.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(authRegister.rejected, (state, action) => {
      state.isLoading = false;
    });

    // auth-login
    builder.addCase(authLogin.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authLogin.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(authLogin.rejected, (state, action) => {
      state.isLoading = false;
    });

    // auth-forgot-password
    builder.addCase(authForgotPassword.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authForgotPassword.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(authForgotPassword.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-profile
    builder.addCase(fetchProfile.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProfile.fulfilled, (state, action) => {
      const { data, success } = action?.payload ?? {};
      state.profile = data;
      localStorage.setItem("profile", data);
      if (success) {
        pipSaveProfile(data ?? null);
      }
      state.isLoading = false;
    });
    builder.addCase(fetchProfile.rejected, (state, action) => {
      state.isLoading = false;
    });

    // auth-change-password
    builder.addCase(changePassword.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.isLoading = false;
    });

    // update-profile
    builder.addCase(updateProfile.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateProfile.fulfilled, (state, action) => {
      const { data, success } = action?.payload ?? {};
      state.profile = data;
      localStorage.setItem("profile", data);
      if (success) {
        pipSaveProfile(data ?? null);
      }
      state.isLoading = false;
    });
    builder.addCase(updateProfile.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchAllSentNotification
    builder.addCase(fetchAllSentNotification.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAllSentNotification.fulfilled, (state, action) => {
      const { data } = action?.payload ?? [];
      state.sentNotification = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchAllSentNotification.rejected, (state, action) => {
      state.isLoading = false;
    });

    // CreateSentNotification
    builder.addCase(CreateSentNotification.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(CreateSentNotification.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(CreateSentNotification.rejected, (state, action) => {
      state.isLoading = false;
    });

    // DeleteSentNotification
    builder.addCase(DeleteSentNotification.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(DeleteSentNotification.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(DeleteSentNotification.rejected, (state, action) => {
      state.isLoading = false;
    });

    // UpdateSentNotification
    builder.addCase(UpdateSentNotification.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(UpdateSentNotification.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(UpdateSentNotification.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-notofication-detail
    builder.addCase(fetchNotificationDetail.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchNotificationDetail.fulfilled, (state, action) => {
      const { data } = action?.payload ?? [];
      state.notificationDetailList = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchNotificationDetail.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const { toggleChange } = authSlice.actions;
export default authSlice.reducer;
